export const LangTexts = {
  en: {
    profile: 'My Profile',
    noMovies: 'Add to Favorites or Watchlist some movies to see them here!',
    favoriteMovies: 'Favorite Movies',
    watchlistMovies: 'Watchlist',
    errorMsg: 'Nothing here yet!',
  },
  'pt-BR': {
    profile: 'Meu Perfil',
    noMovies: 'Favorite ou Watchlist alguns filmes para vê-los aqui!',
    favoriteMovies: 'Filmes Favoritos',
    watchlistMovies: 'Marcados para Assistir mais tarde',
    errorMsg: 'Não encontramos nada..',
  },
};
